import React, { useState } from 'react';
import { useAuth } from '../AuthContext/authContext'; 
import OldVideoHub from './OldVideoHub';
import UploadVideoForm from './UploadVideoForm';
import './VideoHub.css';

const VideoHub = () => {
  const { user } = useAuth(); 
  const [view, setView] = useState('');


  if (user?.role === 'Warden') {
    return <OldVideoHub />;
  }
  return (
    <div className="video-hub">
      {!view && (
        <div className="admin-actions">
          <button onClick={() => setView('fetch')}>Fetch Old Videos</button>
          <button onClick={() => setView('upload')}>Upload New Videos</button>
        </div>
      )}
      {view === 'fetch' && <OldVideoHub />}
      {view === 'upload' && <UploadVideoForm />}
    </div>
  );
};

export default VideoHub;
